

import templateProductDetailPage from '@/app-template/lib/pages/ProductDetailPage.vue';

export default {
  name: "ProductDetailPage",
  components: { templateProductDetailPage },
};
